<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card class="mb-2">
            <div v-if="confirmed">
              <div class="h4 mb-4">Password was changed successfully</div>
              <p class="text-muted">
                To access your account login with your new password.
              </p>
            </div>
            <div v-else>
              <b-form class="px-4">
                <div class="h4 mb-4">
                  Create new password
                </div>
                <p class="text-muted">
                  Enter a new password for your account.
                </p>

                <p class="alert alert-warning" v-if="error_msg">
                  {{ error_msg }}
                </p>

                <b-input-group class="mb-3">
                  <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                  <b-form-input type="text" class="form-control" placeholder="Your email" autocomplete="username-email" v-model="username" disabled />
                </b-input-group>

                <b-input-group class="mb-4">
                  <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                  <b-form-input type="password" class="form-control" placeholder="New password" autocomplete="new-password" v-model="password" />
                </b-input-group>

                <b-input-group class="mb-4">
                  <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                  <b-form-input type="password" class="form-control" placeholder="Confirm password" autocomplete="confirm-password" v-model="password_confirm" />
                </b-input-group>

                <b-row>
                  <b-col>
                    <b-button variant="primary" block class="text-uppercase font-weight-bold py-2" @click="verifyCode">Change password</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </div>
          </b-card>
          <b-row>
            <b-col>
              <b-button variant="link" block class="px-0 pt-3 text-center" to="/login">Back to login</b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  AUTH_PASSWORD_RESET_COMPLETE
} from "@/store/action-types";

export default {
  name: "PasswordResetChange",
  data() {
    return {
      username: this.$route.query.email || null,
      sent: false,
      code: this.$route.query.code || null,
      confirmed: false,
      password: null,
      password_confirm: null,
      error_msg: null
    };
  },
  methods: {
    verifyCode() {
      if (this.password === this.password_confirm) {
        let payload = {
          username: this.username,
          code: this.code,
          password: this.password
        };
        this.$store
          .dispatch(AUTH_PASSWORD_RESET_COMPLETE, payload)
          .then(data => {
            this.confirmed = true;
          })
          .catch(err => {
            const error = this.$store.getters.getAuthenticationError;
            if (error) {
              this.error_msg = error;
            } else {
              this.error_msg =
                "Something went wrong please contact an administrator";
            }
          });
      } else {
        this.error = "Passwords do not match";
      }
    }
  }
};
</script>
